<div class="chat-container">
  <!-- Chat Header -->
  <dc-chat-header
    [agentCard]="agentCard"
    [isAdmin]="isAdmin"
    (showInfoEvent)="showInfo()"
    (settingsClickEvent)="changeUserChatSettings()"
    (restartConversationEvent)="restartConversation($event)">
  </dc-chat-header>

  <!-- Messages List -->
  <dc-chat-messages-list [chatUserSettings]="chatUserSettings" [inputMessages]="messages()"> </dc-chat-messages-list>

  <!-- Chat Footer -->
  <dc-chat-footer [micSettings]="micSettings" [backgroundTasks]="backgroundTasks"> </dc-chat-footer>

  <!-- Info Dialog -->
  <p-dialog [(visible)]="isInfoVisible" [modal]="true" [draggable]="false" [resizable]="false" header="Conversation Info">
    <div class="info-content">
      <h3>Agent Card</h3>
      <pre>{{ agentCard | safeJson }}</pre>

      <h3>User Settings</h3>
      <pre>{{ chatUserSettings | safeJson }}</pre>
    </div>
  </p-dialog>
</div>
